export enum TipoArquivo {
    CADASTRO_PRODUTOS = 'Cadastro de Produtos'
}